import * as yup from 'yup';

const bannerMessageObjectSchema = yup.object({
  message: yup.string().required('A message is required.'),

  startTime: yup.date().nullable().optional(),

  endTime: yup
    .date()
    .nullable()
    .optional()
    // Add conditional validation: if startTime exists, endTime must be after it.
    .when('startTime', ([startTime], schema) => {
      return startTime
        ? schema.min(startTime, 'End time must be after the start time.')
        : schema;
    }),

  beforeLogin: yup.boolean().default(false),
});

export const portalBannersObjectSchema = yup.object({
  admin: yup.array().of(bannerMessageObjectSchema),
  member: yup.array().of(bannerMessageObjectSchema),
  partner: yup.array().of(bannerMessageObjectSchema),
  pharmacy: yup.array().of(bannerMessageObjectSchema).optional(),
});

export const RENDER_INTERVAL = 30 * 1000; //30 seconds in milliseconds
export const REFETCH_INTERVAL = 2 * 60 * 1000; //2 minutes in milliseconds.
